import { useEffect, useState } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchAnnouncementContent } from "../APIClient/apiClient";

export function useAnnouncementContent() {
  const { currentLanguage } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let isActive = true;

    fetchAnnouncementContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }

      if (data && Array.isArray(data.items)) {
        const normalizedItems = data.items
          .map((item, index) => ({
            id: item?.id ?? index,
            message: item?.message || "",
          }))
          .filter((item) => Boolean(item.message));
        setItems(normalizedItems);
        return;
      }

      if (data && Array.isArray(data.messages)) {
        const normalizedItems = data.messages
          .map((message, index) => ({
            id: index,
            message: message || "",
          }))
          .filter((item) => Boolean(item.message));
        setItems(normalizedItems);
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return { items, messages: items.map((item) => item.message) };
}
